import {RepositoryFactory} from "../../scripts/RepositoryFactory";

const ServiceRepository = RepositoryFactory.get('services');

const state = {
    users: [],
    selectedUser: null,
    userDetails: null,
    role: null,
    roles: [
        {text: 'Admin', value: 'admin'},
        {text: 'User', value: 'read'},
        {text: 'Native', value: 'native'},
        {text: 'Display', value: 'display'},
        {text: 'Video', value: 'video'},
    ],
}
const getters = {
    role(state) {
        return state.role; //needed for state access in repository.js
    }
}
const actions = {
    async fetchUsers({state}) {
        let {data} = await ServiceRepository.getUsers();
        if (data.Status) {
            state.users = data.Users;
        }
    },
    async fetchUserDetails({state, commit}) {
        let {data} = await ServiceRepository.getUserDetails(state.selectedUser.UserId);
        if (data.Status) {
            commit('setUserDetails', data);
        }
    },
    async editUser({commit}, payload) {
        let {data} = await ServiceRepository.editUser(payload);
        if (data.Status) {
            commit('setUsers', data.Users);
        }
        return data;
    },
    async deleteUser({commit}, payload) {
        let {data} = await ServiceRepository.deleteUser(payload);
        if (data.Status) {
            commit('setUsers', data.Users);
        }
        return data;
    }
}
const mutations = {
    setUsers(state, payload) {
        state.users = payload;
    },
    setSelectedUser(state, payload) {
        state.selectedUser = payload;
    },
    setUserDetails(state, payload) {
        state.userDetails = payload;
    },
    setUserRole(state, payload) {
        if (state.role === null || state.role !== payload) {
            state.role = payload;
        }
    }
}


export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}